module.exports = __webpack_public_path__ + "static/img/Tom_Hawkins_desktop.81537e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Hawkins_desktop.jpg
// module id = ZWcl
// module chunks = 0